var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.359 9.06662C19.224 8.71562 19.062 8.46722 18.7974 8.20262C18.5328 7.93802 18.2844 7.77602 17.9334 7.64102C17.6688 7.53842 17.2692 7.41422 16.5348 7.38182C15.741 7.34402 15.5034 7.33862 13.4946 7.33862C11.4858 7.33862 11.2482 7.34402 10.4544 7.38182C9.72 7.41422 9.3258 7.53842 9.0558 7.64102C8.7048 7.77602 8.4564 7.93802 8.1918 8.20262C7.9272 8.46722 7.7652 8.71562 7.6302 9.06662C7.5276 9.33122 7.4034 9.73081 7.371 10.4652C7.3332 11.259 7.3278 11.4966 7.3278 13.5054C7.3278 15.5142 7.3332 15.7518 7.371 16.5456C7.4034 17.28 7.5276 17.6742 7.6302 17.9442C7.7652 18.2952 7.9272 18.5436 8.1918 18.8082C8.4564 19.0728 8.7048 19.2348 9.0558 19.3698C9.3204 19.4724 9.72 19.5966 10.4544 19.629C11.2482 19.6668 11.4858 19.6722 13.4946 19.6722C15.5034 19.6722 15.741 19.6668 16.5348 19.629C17.2692 19.5966 17.6634 19.4724 17.9334 19.3698C18.2844 19.2348 18.5328 19.0728 18.7974 18.8082C19.062 18.5436 19.224 18.2952 19.359 17.9442C19.4616 17.6796 19.5858 17.28 19.6182 16.5456C19.656 15.7518 19.6614 15.5142 19.6614 13.5054C19.6614 11.4966 19.656 11.259 19.6182 10.4652C19.5858 9.73081 19.4616 9.33662 19.359 9.06662ZM13.5 17.361C11.367 17.361 9.639 15.633 9.639 13.5C9.639 11.367 11.367 9.63902 13.5 9.63902C15.633 9.63902 17.361 11.367 17.361 13.5C17.361 15.633 15.633 17.361 13.5 17.361ZM17.5122 10.3896C17.0154 10.3896 16.6104 9.98462 16.6104 9.48782C16.6104 8.99102 17.0154 8.58602 17.5122 8.58602C18.009 8.58602 18.414 8.99102 18.414 9.48782C18.414 9.98462 18.009 10.3896 17.5122 10.3896Z",
    fill: "url(#paint0_linear_2_149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2692 15.2717C16.2477 14.2932 16.2477 12.7068 15.2692 11.7283C14.2907 10.7498 12.7043 10.7498 11.7258 11.7283C10.7473 12.7068 10.7473 14.2932 11.7258 15.2717C12.7043 16.2502 14.2907 16.2502 15.2692 15.2717Z",
    fill: "url(#paint1_linear_2_149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.0426 0 0 6.0426 0 13.5C0 20.9574 6.0426 27 13.5 27C20.9574 27 27 20.9574 27 13.5C27 6.0426 20.9574 0 13.5 0ZM20.9736 16.5996C20.9358 17.3988 20.8116 17.9442 20.6226 18.4248C20.4282 18.9216 20.1744 19.3374 19.7532 19.7586C19.3374 20.1744 18.9162 20.4336 18.4194 20.628C17.9388 20.8116 17.3934 20.9412 16.5942 20.979C15.795 21.0168 15.5358 21.0222 13.4946 21.0222C11.4534 21.0222 11.1996 21.0114 10.395 20.979C9.5958 20.9412 9.0504 20.817 8.5698 20.628C8.073 20.4336 7.6572 20.1798 7.236 19.7586C6.8202 19.3428 6.561 18.9216 6.3666 18.4248C6.183 17.9442 6.0534 17.3988 6.0156 16.5996C5.9778 15.8004 5.9724 15.5412 5.9724 13.5C5.9724 11.4588 5.9832 11.205 6.0156 10.4004C6.0534 9.6012 6.1776 9.0558 6.3666 8.5752C6.561 8.0784 6.8148 7.6626 7.236 7.2414C7.6518 6.8256 8.073 6.5664 8.5698 6.372C9.0504 6.1884 9.5958 6.0588 10.395 6.021C11.1942 5.9832 11.4534 5.9778 13.4946 5.9778C15.5358 5.9778 15.7896 5.9886 16.5942 6.021C17.3934 6.0588 17.9388 6.183 18.4194 6.372C18.9162 6.5664 19.332 6.8202 19.7532 7.2414C20.1744 7.6626 20.4282 8.0784 20.6226 8.5752C20.8062 9.0558 20.9358 9.6012 20.9736 10.4004C21.0114 11.1996 21.0168 11.4588 21.0168 13.5C21.0168 15.5412 21.006 15.795 20.9736 16.5996Z",
    fill: "url(#paint2_linear_2_149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_149",
    x1: 13.4946,
    y1: 7.33862,
    x2: 13.4946,
    y2: 19.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_149",
    x1: 11.7258,
    y1: 11.7283,
    x2: 15.2692,
    y2: 15.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_149",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgGradient);
export default __webpack_public_path__ + "static/media/IG_gradient.4d55c9cfbf875400089c602bd9123604.svg";
export { ForwardRef as ReactComponent };